import Api from '../api';
const END_POINT = 'admin/entities';

export default {
    state: {
        entities: [],
    },

    getters: {
        getEntities: state => state.entities
    },

    mutations: {
        setEntities: (state, entities) => state.entities = entities
    },

    actions: {
        async fetchEntities({commit}){
            const response = await Api.get(END_POINT);
            commit('setEntities', response.body.data);
        }
    }

}